import { toSnakeCase } from '@/helpers/string-helpers'
import { useIntl } from '@/intl'
import {
  FilterContainer,
  FilterItemOption,
  FilterItemOptionContent,
  FilterItemOptionControl,
  FilterItemOptionTrailing,
  FilterItemOptionWrapper,
  FilterItemsContainer,
  FilterLabel,
  FilterOptionPrice,
  FilterOptionValue,
} from '@/scopes/checkout/components/services/CarRentalFilteringService/FilterableCars/Filters/Filters'
import { createCarEvent } from '@/scopes/checkout/domain/analytics'
import { updateSingleValueFilter } from '@/scopes/checkout/filterableCars/domain/actions'
import { useFilter } from '@/scopes/checkout/filterableCars/domain/hooks'
import { CarFilterType } from '@/scopes/checkout/filterableCars/domain/types'
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'
import { ListItem, RadioButton, RadioButtonGroup } from '@sunwebgroup/ui-components/uds/index'
import * as React from 'react'

export function TransmissionFilter() {
  const { filter, setFilterValue } = useFilter(CarFilterType.Transmission)
  const intl = useIntl()
  const { sendEvent } = useAnalytics()

  const handleFilterValueChange = React.useCallback(
    (value: string) => {
      if (!value)
        return
      if (!filter)
        return
      setFilterValue(updateSingleValueFilter({ value })(filter))

      sendEvent(
        createCarEvent({
          result: 'Filter selected',
          type: value,
          description: 'Transmission',
          element: 'radiobutton',
          validated: true,
        }),
      )
    },
    [sendEvent, filter, setFilterValue],
  )

  if (!filter)
    return null

  const { filterOptions, selectedFilter } = filter

  return (
    <FilterContainer>
      <FilterLabel>{intl.formatMessage({ id: `checkout_steps_ancillaries_car_rental_filtering_filters_transmission_type_label` })}</FilterLabel>
      <RadioButtonGroup value={selectedFilter ?? undefined} onValueChange={handleFilterValueChange}>
        <FilterItemsContainer>
          {filterOptions.map((option) => {
            const { value, name, quantity, startingPrice } = option

            return (
              <FilterItemOptionWrapper key={value}>
                <ListItem variant="outlined">
                  <FilterItemOption>
                    <FilterItemOptionControl>
                      <RadioButton value={value} />
                    </FilterItemOptionControl>
                    <FilterItemOptionContent>
                      <FilterOptionValue>
                        {intl.formatMessage({ id: `checkout_steps_ancillaries_car_rental_filtering_filters_transmission_type_${toSnakeCase(name)}_text`, defaultMessage: name })}
                        {' '}
                        {quantity ? `(${quantity})` : ''}
                      </FilterOptionValue>
                    </FilterItemOptionContent>
                    {startingPrice && (
                      <FilterItemOptionTrailing>
                        <FilterOptionPrice>
                          {intl.formatMessage({ id: `checkout_steps_ancillaries_car_rental_filtering_filters_from_starting_price_text` }, { price: intl.formatTruncatedCurrency(startingPrice) })}
                        </FilterOptionPrice>
                      </FilterItemOptionTrailing>
                    )}
                  </FilterItemOption>
                </ListItem>
              </FilterItemOptionWrapper>
            )
          })}
        </FilterItemsContainer>
      </RadioButtonGroup>
    </FilterContainer>
  )
}
